export enum TableColumnsNames {
    Violations = "violations",
    Inventory = "inventory",
    Hygiene = "hygiene",
    PlaybooksExecutionsHistory = "playbooksExecutionsHistory",
}
